import React, { useState } from 'react';
import { toast } from 'sonner';
import { AlertTriangle, ShieldCheck } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { assistApi } from './assistApi';

const STAGES = [[2, 'Company profile'], [3, 'Online presence'], [4, 'Insurance'], [5, 'First installation'], [6, 'Photos'], [7, 'Customer review']];

const isEmpty = (n, s = {}) => ({
  2: s.status !== 'complete',
  3: !['website', 'facebook', 'instagram', 'tiktok', 'linkedin'].some((k) => (s[k] || '').trim()),
  4: !(s.expiry_date || s.certificate_gridfs_id),
  5: !(s.project_name || '').trim(),
  6: !(s.photos || []).length,
  7: !s.rating,
}[n]);

export function ApproveNowDialog({ open, onClose, record, brandLabel, notify, onApproved }) {
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const keys = { 2: 'stage2_profile', 3: 'stage3_online', 4: 'stage4_insurance', 5: 'stage5_first_install', 6: 'stage6_documentation', 7: 'stage7_review' };
  const empty = STAGES.filter(([n]) => isEmpty(n, record?.[keys[n]])).map(([, l]) => l);
  const go = async () => {
    setBusy(true);
    try {
      const d = await assistApi.approveNow(record.user_id, record.brand, { notes, notify });
      toast.success(`${brandLabel} Ox Approved granted${d.notified?.email || d.notified?.sms ? ' — installer notified' : ''}`);
      onApproved(d); onClose();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="approve-now-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-emerald-600" /> Approve now · {brandLabel}</DialogTitle></DialogHeader>
        <p className="text-sm text-gray-700">Every stage will be marked complete and the Ox Approved badge granted immediately.</p>
        {empty.length > 0 && (
          <div className="flex gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="approve-now-warning">
            <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />
            <div>Nothing has been entered for: <strong>{empty.join(', ')}</strong>. These will be recorded as skipped on the installer's record.</div>
          </div>
        )}
        <Textarea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Why are you approving? e.g. verified by phone / paperwork seen in person" data-testid="approve-now-notes" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button onClick={go} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="approve-now-confirm">{busy ? 'Approving…' : 'Approve installer'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
